import type { Spelling } from '@corocanto/scoring';

/**
 * Key for one written note: part, written measure, beat offset and written pitch (the two lines
 * of a divided part can start on the same beat, as a chord or in two voices). A note result
 * stored without a spelling keys on its position only.
 */
export function noteColorKey(partId: string, measureIndex: number, beatOffset: number, spelling: Spelling | undefined): string {
  const pitch = spelling ? `${spelling.step}${spelling.alter}/${spelling.octave}` : '';
  return `${partId}|${measureIndex}|${beatOffset.toFixed(3)}|${pitch}`;
}
